import { parseISO } from 'date-fns';
import { Goal } from '../goals';
import { sum } from '../util/arrays';
import { isNullish } from '../util/types';
import { makeGoalVSG } from './makeGoalVSG';
import { arrayFromTickRange, findValueNode } from './ticks';
import {
    AccountValueNode,
    BaseVSGContext,
    SnapshotBase,
    TickRange,
    ValueNode,
    ValueSeries,
} from './types';

export type GoalsVSGValueNode = ValueNode<{
    balance: number | null;
    values: AccountValueNode[];
}>;

export const buildGoalsValueSeries = ({
    goals,
    snapshotsByFinancialEntityId,
    ctx,
    range,
}: {
    goals: Goal[];
    snapshotsByFinancialEntityId: Record<string, SnapshotBase[] | undefined>;
    ctx: BaseVSGContext;
    range: TickRange;
}): ValueSeries<GoalsVSGValueNode> => {
    const goalVSGs = goals.map((goal) =>
        makeGoalVSG({
            goal,
            snapshotsByFinancialEntityId,
            ctx,
            params: {
                formatValueNode: ({ goal, valueNode }) => ({
                    ...valueNode,
                    label: goal.name,
                }),
            },
        })
    );

    const valueSeriesArray = goalVSGs.map((vsg) => vsg(range));
    const values = arrayFromTickRange(range).map((tick) => {
        const tickValues = valueSeriesArray.map((vs) =>
            findValueNode(vs, tick)
        );
        const balance = tickValues.every((v) => isNullish(v.balance))
            ? null
            : sum(tickValues, (v) => v.balance ?? 0);
        return { ...tick, values: tickValues, balance };
    });

    return { ...range, startDateObj: parseISO(range.startDate), values };
};
